<template>
  <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
    <div class="page-subtitle mt-5 mb-4">Profile Photo</div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" xl="4" lg="4" md="4" sm="4">
          <image-cropper
            v-model="show"
            @change="uploadPhoto"
            @close="show = false"
          />

          <div
            class="upload-container mb-4"
            :class="user && user.avatar ? 'border-0' : ''"
            v-cloak
            @drop.prevent="onFileChange"
            @dragover.prevent
          >
            <b-avatar
              button
              rounded
              badge
              badge-top
              badge-offset="1.5rem"
              alt="Avatar"
              class="ml-0 mr-auto edit-avatar"
              variant="transparent"
              badge-variant="transparent"
              v-if="user && user.avatar"
              :style="
                'max-width: 100%; max-height: 100%; width: 100%; height: auto;'
              "
              :src="user.avatar.url"
              @click="show = true"
            >
              <template #badge>
                <b-icon
                  icon="pencil-square"
                  scale="1.5"
                  class="text-light"
                ></b-icon>
              </template>
            </b-avatar>

            <b-avatar
              v-else
              button
              rounded
              badge
              badge-top
              badge-offset="1.5rem"
              alt="Avatar"
              class="ml-0 mr-auto edit-avatar upload-container-dashed"
              variant="transparent"
              badge-variant="transparent"
              :style="'width: 100%; height: auto;'"
              :src="require('@/assets/icons/image@2x.png')"
              :srcset="`${require('@/assets/icons/image@2x.png')}`"
              @click="show = true"
            >
              <template #badge>
                <b-icon icon="pencil-square" scale="1.5"></b-icon>
              </template>
            </b-avatar>

            <!-- <b-img
              rounded
              v-else
              width="310"
              alt="Photos"
              class="ml-0 mr-auto"
              :src="require('@/assets/icons/image.png')"
              :srcset="`${require('@/assets/icons/image@2x.png')}`"
            ></b-img> -->
          </div>
        </b-col>

        <b-col cols="12" xl="6" lg="6" md="6" sm="6">
          <!-- <div class="mt-5 pt-4">
            <b-button block variant="primary" @click="show = true"
              >Upload photo</b-button
            >
          </div>
          <div class="text-center mt-3">Or drag them in</div> -->
        </b-col>
      </b-row>
    </b-container>

    <div class="page-subtitle mt-4 mb-4">Personal Details</div>
    <b-form-group id="input-group-full-name">
      <label class="font-weight-bold">Full Name</label>
      <b-form-input
        id="input-full-name"
        v-model="form.full_name"
        type="text"
        required
        placeholder="Enter Full Name"
        :state="state.full_name"
        aria-describedby="input-full-name-feedback"
      ></b-form-input>

      <b-form-invalid-feedback id="input-full-name-feedback">
        <!-- eslint-disable-next-line -->
        {{ errors.full_name }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-row>
      <b-col>
        <div class="datepicker-container">
          <label class="font-weight-bold">Date of Birth</label>
          <b-form-input
            id="input-date"
            :state="state.birthdate"
            type="text"
            required
            placeholder="DD/MM/YYYY"
            aria-describedby="input-date-feedback"
            maxlength="10"
            v-model="formattedDate"
            :formatter="formatDate"
          />
        </div>

        <b-form-invalid-feedback id="input-birth-date-feedback">
          <!-- eslint-disable-next-line -->
        {{ errors.birthdate }}
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <label class="font-weight-bold mt-3">USI Number</label>
    <b-input-group id="input-group-usi">
      <b-form-input
        id="input-usi"
        :class="state.usi ? 'with-usi' : 'with-no-usi'"
        v-model="form.usi"
        type="text"
        placeholder="Enter USI Number"
        aria-describedby="input-usi-feedback"
      >
      </b-form-input>
      <template #append>
        <b-input-group-text
          id="popover-button-sync"
          class="clickable"
          :class="state.usi ? 'with-usi' : 'with-no-usi'"
        >
          <b-icon
            icon="info-circle"
            variant="dark"
            @click="showFindUsi = !showFindUsi"
          />
        </b-input-group-text>
        <b-popover :show.sync="showFindUsi" target="popover-button-sync">
          Find your USI Number
          <strong
            ><b-link
              href="https://www.usi.gov.au/students/find-your-usi"
              target="_blank"
              >here</b-link
            ></strong
          >
        </b-popover>
      </template>
    </b-input-group>

    <b-row class="my-5 pb-5">
      <b-col>
        <b-button
          block
          class="btn-outlined bg-white text-dark"
          variant="outline-secondary"
          @click="resetForm"
          >Discard</b-button
        >
      </b-col>
      <b-col>
        <b-button
          block
          class="btn-outlined"
          type="submit"
          variant="primary"
          :disabled="loading"
        >
          <b-spinner small v-if="loading"></b-spinner>
          <div v-else>Save</div>
        </b-button>
      </b-col>
    </b-row>

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
      >Your profile has been updated</b-alert
    >
  </b-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageCropper from '@/components/modals/ImageCropper'

export default {
  components: {
    ImageCropper
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  data() {
    return {
      loading: false,
      show: false,
      formattedDate: null,
      dismissCountDown: 0,
      showFindUsi: false,
      form: {
        full_name: null,
        usi: null,
        birthdate: null
      },
      state: {
        full_name: null,
        usi: null,
        birthdate: null
      },
      errors: {
        full_name: null,
        birthdate: null
      }
    }
  },

  methods: {
    ...mapActions({
      changeAvatar: 'auth/changeAvatar',
      updateUser: 'auth/updateUser',
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    }),

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    onFileChange(e) {
      this.show = true
      this.$root.$emit('fileChange', e)
    },

    resetForm() {
      this.form.full_name = this.user.full_name || null
      this.form.usi = this.user.usi || null
      this.form.birthdate = this.user.birthdate || null
      this.formattedDate = this.parseDate(this.form.birthdate)
      this.scrollToTop()
    },

    async uploadPhoto(image) {
      this.loading = true
      let data = new FormData()
      data.append('avatar', image)
      await this.changeAvatar(data)
      this.loading = false
      this.$root.$emit('uploadComplete')
    },

    async onSubmit() {
      this.loading = true
      this.form.birthdate = this.convertToISO(this.formattedDate)
      await this.updateUser(this.form)
      this.loading = false
      this.scrollToTop()
      this.dismissCountDown = 3
    }
  },

  created() {
    if (!this.user) {
      this.getAuthenticatedUser().then(() => this.resetForm())
    } else {
      this.resetForm()
    }
  },

  watch: {
    'form.full_name'() {
      this.state.full_name = this.form.full_name.length !== 0
      this.errors.full_name = 'This field is required'
    },

    'form.usi'() {
      this.state.usi = this.form.usi.length !== 0 ? true : null
    },

    formattedDate() {
      this.state.birthdate = this.formattedDate.length !== 0
      this.errors.birthdate = 'This field is required'
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-select {
  background: none;
}
.append-icon {
  z-index: 1;
}
/deep/ .edit-avatar,
/deep/ .edit-avatar[href] {
  border-radius: 16px !important;

  &.btn:not(:disabled):not(.disabled):hover {
    .b-avatar-img {
      img {
        transform: none !important;
      }
    }
  }
}
.clickable {
  cursor: pointer;
}
.with-usi {
  background: white;
  border-color: #28a745;
}
.with-no-usi {
  background: white;
  border: 2px solid #e5e5e5;
}
</style>
